import { environment } from '../../../environments/environment';

/**
 * Backend origin (e.g. http://localhost:8001), derived from the API base so
 * media resolution needs no extra environment entry.
 */
const BACKEND_ORIGIN = new URL(environment.apiUrl, window.location.origin).origin;

/**
 * Resolve a backend media URL to an absolute one.
 *
 * REST responses carry absolute file URLs (DRF builds them from the request),
 * but WebSocket payloads are serialized without a request, so in dev their
 * FileFields arrive RELATIVE (`/mediafiles/…`) — and the browser would resolve
 * them against the frontend origin, 404ing. Prod S3 URLs are always absolute
 * (signed), so this is a passthrough there. Local object/blob/data URLs pass
 * through untouched.
 */
export function mediaUrl(path: string): string;
export function mediaUrl(path: string | null | undefined): string | null;
export function mediaUrl(path: string | null | undefined): string | null {
  if (!path) return null;
  if (/^(https?:|blob:|data:)/i.test(path)) return path;
  return new URL(path, BACKEND_ORIGIN).toString();
}
